export default {"src":"/_next/static/media/hipotecario_seguros.7f36fdd0.svg","height":273,"width":1208,"blurWidth":0,"blurHeight":0};